// Remote Power Management
export function searchRemotePowerManagement(query) {
  return { path: `remote_power_managements${query}` };
}

export function getRemotePowerManagement(id) {
  return { path: `remote_power_managements/${id}` };
}

export function createRemotePowerManagement(name) {
  return {
    path: 'remote_power_managements',
    method: 'POST',
    body: JSON.stringify({
      name,
    }),
  };
}

export function updateRemotePowerManagement(id, name) {
  return {
    path: `remote_power_managements/${id}`,
    method: 'PUT',
    body: JSON.stringify({
      name,
    }),
  };
}

export function deleteRemotePowerManagement(id) {
  return {
    path: `remote_power_managements/${id}`,
    method: 'DELETE',
  };
}
